import { getProductById, quantityOptions } from '../catalog';
import { useCart } from '../context/CartContext';

export default function CartItem({ line }) {
  const { updateLinePieces, changeLineWeight, removeLine } = useCart();
  const imageSrc = line.image ?? getProductById(line.productId)?.image;

  return (
    <li className="cart-page-item">
      <div className="cart-page-item-image">
        <img src={imageSrc} alt="" />
      </div>
      <div className="cart-page-item-body">
        <h3 className="cart-page-item-title">{line.name}</h3>

        <label className="cart-field-label" htmlFor={`weight-${line.key}`}>
          Weight
        </label>
        <div className="select-wrap select-wrap--narrow">
          <select
            id={`weight-${line.key}`}
            className="product-size-select weight-select"
            value={line.weight}
            onChange={(e) => changeLineWeight(line.key, e.target.value)}
          >
            {quantityOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        <p className="cart-field-label">Quantity</p>
        <div className="quantity-control modern-quantity-control cart-qty">
          <button
            type="button"
            className="qty-btn qty-btn-minus"
            onClick={() => updateLinePieces(line.key, line.pieces - 1)}
            disabled={line.pieces <= 1}
            aria-label="Decrease quantity"
          >
            −
          </button>
          <span className="qty-value">{line.pieces}</span>
          <button
            type="button"
            className="qty-btn qty-btn-plus"
            onClick={() => updateLinePieces(line.key, line.pieces + 1)}
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>

        <button type="button" className="cart-remove-btn" onClick={() => removeLine(line.key)}>
          Remove
        </button>
      </div>
    </li>
  );
}
